// extracted by mini-css-extract-plugin
module.exports = {"label":"CreateOrEditApiKeyPage_label__2n_WU"};